<template>
    <div>
        <div class="foot">
            <div class="footer">
                Copyright © 2010 Brassica Database.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Foot"
    }
</script>

<style>
    .foot .footer {
        color: #407338;
        text-align: center;
        font-size: 18px;
    }

    .foot {
        margin: 0px auto;
        width: 1200px;
        background-color: #D1E4D4;
    }
</style>